module.exports = __webpack_public_path__ + "img/sm-twitter.15151774.svg";